export const controlValueHelpers = {
  methods: {
    getControlValueDesc(id, controlValueType) {
      let item = '';
      if (this[controlValueType] !== null) {
        item = this[controlValueType].find(cv => {
          return parseInt(cv.id) === parseInt(id);
        });
      }
      return typeof item !== 'undefined' ? item.description : '';
    },
    getControlValue(id, controlValueType) {
      let item = '';
      if (this[controlValueType] !== null) {
        item = this[controlValueType].find(cv => {
          return parseInt(cv.id) === parseInt(id);
        });
      }
      return typeof item !== 'undefined' ? item.value : '';
    },
    controlValueDropdown (controlValue) {

      let dd = {};

      let cValues = this.$store.getters[ 'admin/activeControlValues' ](controlValue);

      if (cValues) {
        cValues.forEach(cValue => {
          dd[cValue.id.toString()] = cValue.description;
        });
      }

      return dd;
    },
  },
};
